import React from "react";
import { Platform, Settings, Text, View } from "react-native";
import styles from "../../../stylesheet";
import { SettingsStackParamList } from "../types";
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createStackNavigator } from "@react-navigation/stack";
import horizontalAnimation from "./functions/cardAnimation";
import ProfileScreen from "../screens/MidLevel/SettingsScreens/ProfileScreen";
import AchievementsScreen from "../screens/MidLevel/SettingsScreens/AchievementsScreen";
import UpgradeScreen from "../screens/MidLevel/UpgradeScreen/UpgradeScreen";
import CompanyProfile from '../screens/MidLevel/SettingsScreens/CompanyScreen';
import CreditsScreen from "../screens/MidLevel/SettingsScreens/CreditsScreen";
const StatisticsScreen = React.lazy(() => import("../screens/MidLevel/SettingsScreens/StatisticsScreen"));
import AffiliateScreen from "@navigation/screens/MidLevel/SettingsScreens/AffiliateScreen";
import Context from "@navigation/screens/MidLevel/SettingsScreens/Context";
import API from "@navigation/screens/MidLevel/SettingsScreens/APIScreen";
import StoreSettings from "@navigation/screens/TopLevel/StoreScreen/StoreSettings";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import SettingsMenu from "@navigation/screens/MidLevel/SettingsScreens/SettingsMenu";
import LanguageScreen from "@navigation/screens/MidLevel/SettingsScreens/LanguageScreen";

const SettingsStack = Platform.select({default: createNativeStackNavigator<SettingsStackParamList>(), web: createStackNavigator<SettingsStackParamList>()})

const SettingsNavigator = () => {
const theme = themeSelector();

  // Memoize screenOptions to prevent unnecessary re-renders of child screens
  const screenOptions = React.useMemo(() => ({
    headerShown: false,
    cardStyle: {
      backgroundColor: theme ? "white" : "black",
    }
  }), [theme]);

  return (
    <View style={{ flex: 1, flexDirection: 'row' }}>
        <SettingsStack.Navigator
        screenOptions={screenOptions}
        initialRouteName="SettingsMenu">
        <SettingsStack.Screen
          name="SettingsMenu"
          component={SettingsMenu}
          options={{ headerTitle: 'Settings Menu' }} />
          <SettingsStack.Screen
            name="Profile"
            component={ProfileScreen}
            options={{ headerTitle: 'Profile' }} />
        <SettingsStack.Screen
          name="Context"
          component={Context}
          options={{ headerTitle: 'Context' }} />
          <SettingsStack.Screen
            name="Achievements"
            component={AchievementsScreen}
            options={{ headerTitle: 'Achievements' }} />
            <SettingsStack.Screen
            name="Statistics"
          options={{ headerTitle: 'Statistics' }}
          component={() => (
            <React.Suspense fallback={<View><Text>Loading...</Text></View>}>
              <StatisticsScreen />
            </React.Suspense>
          )} />
          <SettingsStack.Screen
            name="Company"
            component={CompanyProfile}
            options={{ headerTitle: 'Company Profile' }} />
          <SettingsStack.Screen
            name='Upgrade'
            component={UpgradeScreen}
            options={{ headerTitle: 'Upgrade Screen' }} />
            <SettingsStack.Screen 
            name="Affiliate"
            component={AffiliateScreen}
             />
             <SettingsStack.Screen
          name="StoreSettings"
          component={StoreSettings}
          options={{ headerTitle: 'Store Settings' }} />
        <SettingsStack.Screen
            name="API"
            component={API}
            options={{ headerTitle: 'API' }} />
          <SettingsStack.Screen
            name="Credits"
            component={CreditsScreen}
            options={{ headerTitle: 'Credits' }} />
        <SettingsStack.Screen
          name="Language"
          component={LanguageScreen}
          options={{ headerTitle: 'Language' }} />
        </SettingsStack.Navigator>
    </View>
  );
}

export { SettingsNavigator, SettingsStack };